import React from 'react';
import { Link } from 'react-router-dom';

import Image from 'components/Image';
import Loader from 'components/Loader';
import PATHS from 'routes/paths';

import { insights as TEXT } from 'locales/en';
import { CURRENCY_SYMBOL } from 'utils/transform';
import { priceForAPI } from 'utils/price';

const ActiveFundraisers = ({ isLoading, data }) => {
  return (
    <>
      <h2 className="font-bold mt-7 mx-2 mb-2">{TEXT.fundraisers.title}</h2>
      {isLoading ? (
        <div className="relative min-h-60">
          <Loader
            isBarVisible={false}
            fullScreen={false}
            className="pt-3 h-full justify-center items-center"
          />
        </div>
      ) : !!data.length ? (
        <>
          {data.map((fundraiser, idx) => (
            <div
              key={fundraiser.id}
              className="card rounded lg:grid lg:grid-cols-2 justify-between p-5 lg:p-7 mb-3"
            >
              <div className="items-center flex mb-5 lg:mb-0">
                <div className="w-10 h-10 lg:w-16 lg:h-16 overflow-hidden rounded-md border border-gray-100 flex">
                  <Image src={fundraiser.image} alt={fundraiser.name} />
                </div>
                <p className="font-bold text-lg ml-5">{fundraiser.name}</p>
              </div>
              <div className="flex flex-col justify-center lg:w-4/6 lg:ml-auto">
                <span className="font-bold text-base text-left mb-3 lg:mb-2">
                  {CURRENCY_SYMBOL.EUR}
                  {fundraiser.raised} {TEXT.raised}
                  <span className="font-normal text-javelin-gray-light">
                    {' '}
                    of {CURRENCY_SYMBOL.EUR}
                    {fundraiser.goal} {TEXT.goal}
                  </span>
                </span>
                <div className="h-1.5 w-full bg-gray-100 overflow-hidden">
                  <div
                    style={{
                      width: `${
                        (priceForAPI(fundraiser.raised) /
                          priceForAPI(fundraiser.goal)) *
                        100
                      }%`,
                    }}
                    className="bg-brand-primary h-full"
                  ></div>
                </div>
              </div>
            </div>
          ))}
          <Link
            to={PATHS.fundraisers}
            className="text-xs underline text-javelin-gray-light place-self-end mt-auto self-end text-right"
          >
            {TEXT.fundraisers.view}
          </Link>
        </>
      ) : (
        <span className="mx-2 text-javelin-gray-dark text-opacity-80 lg:text-base">
          {TEXT.noActiveFundraisers.text}
          <Link to={PATHS.fundraisers} className="text-brand-primary">
            {TEXT.noActiveFundraisers.live}
          </Link>
          {TEXT.noActiveFundraisers.or}
          <Link to={PATHS.fundraisersNew} className="text-brand-primary">
            {TEXT.noActiveFundraisers.create}
          </Link>
        </span>
      )}
    </>
  );
};

export default ActiveFundraisers;
